import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { OverdueVehicleUsagePage } from "@/features/tasks/pages/overdue-vehicle-usage-page/overdue-vehicle-usage-page";
import { overdueVehicleUsageFilterSchema } from "@/features/tasks/schemas/overdue-vehicle-usage-filter.schema";

export const Route = createFileRoute("/_authenticated/admin/tasks/overdue/")({
	head: () => pageTitle("Overdue Vehicle Usages"),
	component: OverdueVehicleUsagePage,
	validateSearch: zodValidator(overdueVehicleUsageFilterSchema),
});
